import { render, staticRenderFns } from "./Residence.vue?vue&type=template&id=ea07e02a&scoped=true"
import script from "./Residence.vue?vue&type=script&lang=js"
export * from "./Residence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea07e02a",
  null
  
)

export default component.exports